export const detectPreferredLanguage = (): 'en' | 'fr' => {
  // Get language from URL first (highest priority)
  const urlLang = window.location.pathname.split('/')[1];
  if (urlLang === 'fr') return 'fr';
  if (urlLang === 'en') return 'en';
  
  // If no URL language, detect from browser preferences
  const browserLang = navigator.language || navigator.languages?.[0] || 'en';
  
  
  // Check if it's French (including variants like fr-FR, fr-CA, etc.)
  if (browserLang.startsWith('fr')) {
    return 'fr';
  }
  
  // Default to English for all other languages
  return 'en';
}; 